import React from 'react';
import { List, Radio, RadioGroup } from '@mui/material';
import { FormControlLabel } from '~/UIKit';
import { makeStyles } from '~/UIKit/Style';
import { BORDER_COLOR, LIGHT_BLUE, NOTE_RED } from '~/Constants/Colors.constants';
import { IModalSelectPopoverItem, ModalSelectPopoverItem } from './ModalSelectPopoverItem';

const useStyles = makeStyles(
  () => ({
    list: {
      borderTop: `1px solid ${BORDER_COLOR}`,
      margin: '0 -15px',
      padding: 0,
    },
    note: {
      background: LIGHT_BLUE,
      borderTop: `1px solid ${BORDER_COLOR}`,
      borderBottom: `1px solid ${BORDER_COLOR}`,
      margin: '0 -15px',
      padding: 15,
    },
    noteHighlighted: {
      color: NOTE_RED,
    },

    radioGroup: {
      marginLeft: 'auto',
    },
    radio: {
      marginRight: 0,
    },
  }),
  { name: 'ModalSelectRadioGroupList' },
);

interface IModalSelectRadioGroupList {
  list: Omit<IModalSelectPopoverItem, 'onClick' | 'children'>[];
  idName?: string;
  selectedId: string | number;
  onSelect: (item: any) => void;
}

export const ModalSelectRadioGroupList = ({
  list,
  idName = 'id',
  onSelect,
  selectedId,
}: IModalSelectRadioGroupList) => {
  const { classes } = useStyles();

  return (
    <List className={classes.list} data-testid="ModalSelectRadioGroupList">
      {list.map((item) => (
        <ModalSelectPopoverItem
          key={String(item[idName as keyof typeof item])}
          onClick={() => onSelect(item)}
          icon={item.icon}
          imageUrl={item.imageUrl}
          name={item.name}
          testId="ListItem"
        >
          <RadioGroup
            aria-label="RadioGroup"
            name={item.name}
            value={selectedId}
            onChange={() => onSelect(item)}
            className={classes.radioGroup}
          >
            <FormControlLabel
              value={item[idName as keyof typeof item]}
              control={<Radio />}
              label=""
              className={classes.radio}
              checked={item[idName as keyof typeof item] === selectedId}
            />
          </RadioGroup>
        </ModalSelectPopoverItem>
      ))}
    </List>
  );
};
